var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top',{staticClass:"navs"}),_vm._v(" "),_c('navC',{class:{ 'fix-nav': _vm.navFixed }}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('model'),_vm._v(" "),_c('footerC'),_vm._v(" "),_c('login-entry')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afeef2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/portalNormal.vue
// module id = null
// module chunks = 